module.exports = __webpack_public_path__ + "static/media/Daedap2 Translated by J_Lee_77777.d8bb58a6.md";